export default __webpack_public_path__ + "static/stage-1_3-0bcc758b0481e156047588ecf814fea2.jpg";